import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import __isEmpty from 'lodash/isEmpty';

import butter from '../../services/butter-client';

import '../Category/Category.scss';
import PostListItem from '../../components/PostListItem';

const { detect, detectDevice } = require('../../services/detect-browser');
const deviceInfo = {
  browser: detect(),
  device: detectDevice()
};

class Tag extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tag: {}
    };
  }

  componentDidMount() {
    const { match } = this.props;

    butter.tag.retrieve(match.params.tag, { include: 'recent_posts' }).then((response) => {
      this.setState({ tag: response.data.data });
    });

    if (this.context.mixpanel) this.context.mixpanel.track('Blog Page: Posts By Tag', { tag: this.state.tag.slug });
    setTimeout(() => {
      window.dataLayer.push({
        'event': 'virtualPageView',
        'deviceType': deviceInfo.device,
        'deviceOS': deviceInfo.browser.os,
        'page': {
          'title': 'Blog Page: Posts By Tag',
          'url': this.props.location.pathname,
        }
      });
    }, 0);


  }

  render() {
    if (__isEmpty(this.state.tag)) {
      return <div>Loading...</div>
    }

    const tag = this.state.tag;
    return (
      <div className="app">
        <Helmet>
          <title>{`${tag.name} | codeSpark Blog`}</title>
          <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
          <meta property="og:title" content={tag.name} />
          <meta property="og:description" content="Learn-to-code Tips for Teachers and Parents from codeSpark Academy. Don't miss out on the Foo Fun in codeSpark Academy. " />
          <meta name="twitter:card" content="app" />
          <meta name="twitter:site" content="@codesparkapp" />
          <meta name="twitter:description" content="Learn-to-code Tips for Teachers and Parents from codeSpark Academy. Don't miss out on the Foo Fun in codeSpark Academy." />
          <meta name="twitter:app:country" content="US" />
          <meta name="twitter:app:id:iphone" content="923441570" />
          <meta name="twitter:app:id:ipad" content="923441570" />
          <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="page posts-by-tag-page">
          <h1 className="page-title">Posts by Tag: &ldquo;{tag.name}&rdquo;</h1>

          <div className="posts">
            {
              tag.recent_posts.length === 0 &&
              <div className="no-results">
                <h2>Sorry, there are currently no posts associated with this tag.</h2>
              </div>
            }
            {
              tag.recent_posts.map((post, key) => {
                return (
                  <PostListItem key={key} layout="eighth" post={post} />
                )
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Tag);
